import React from 'react';

import { css } from 'glamor';

export default (props = {}) => (
  <svg { ...css({display: 'block', width: props.width || 20, height: props.height || 14 })} xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
    <defs>
      <filter id="a" y="-5%" filterUnits="objectBoundingBox">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5"/>
        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    <g fill="#FFF" fillRule="evenodd" filter="url(#a)" transform="translate(0 -4)">
      <path fillRule="nonzero" d="M18.595 5.018a.805.805 0 0 0-.807-.034l-3.308 1.73V6.56c0-1.414-1.111-2.56-2.481-2.56H3.48C2.111 4 1 5.146 1 6.56v6.88C1 14.854 2.11 16 3.481 16h8.528c1.37 0 2.481-1.146 2.481-2.56v-.154l3.309 1.73a.805.805 0 0 0 .807-.034.86.86 0 0 0 .394-.727v-8.51a.859.859 0 0 0-.405-.727zm-5.759 8.422a.84.84 0 0 1-.827.853H3.48a.84.84 0 0 1-.827-.853V6.56a.84.84 0 0 1 .827-.853h8.528a.84.84 0 0 1 .827.853v6.88zm4.5-.577L14.49 11.37V8.628l2.845-1.494v5.73z"/>
      <path stroke="#FFF" strokeWidth=".75" d="M3.027 4.901h9.588l.925.933v2.158l4.846-2.158v8.406L13.54 11.95v2.289l-.925.962H3.772l-1.877-.962V6.133z"/>
    </g>
  </svg>

);



// WEBPACK FOOTER //
// ../src/client/components/icons/VideoIndicator.js